import OldSiteRedirectAlert from './OldSiteRedirectAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function NoQueryEntered() {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "no-query-entered",
    paddingBlockStart: "1000",
    paddingBlockEnd: "1200",
    as: "div",
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "1200",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-ui.search.noQuery"
      })
    }), /*#__PURE__*/_jsx(OldSiteRedirectAlert, {})]
  });
}
export default NoQueryEntered;